// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./yousheGB.ttf");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./alimama.ttf");
exports = ___CSS_LOADER_API_IMPORT___(true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, "@font-face {\n  font-family: \"yousheGB-Regular\";\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n}\n@font-face {\n  font-family: \"alimama-Regular\";\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");\n}", "",{"version":3,"sources":["/Users/yangjiaqi/Desktop/华采找鱼鱼/深圳金枪鱼PC0830/src/assets/fonts/text.css","text.css"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,4CAAA;ACCF;ADCA;EACE,8BAAA;EACA,4CAAA;ACCF","file":"text.css","sourcesContent":["@font-face {\n  font-family: \"yousheGB-Regular\";\n  src: url('./yousheGB.ttf');\n}\n@font-face {\n  font-family: \"alimama-Regular\";\n  src: url('./alimama.ttf');\n}","@font-face {\n  font-family: \"yousheGB-Regular\";\n  src: url('yousheGB.ttf');\n}\n@font-face {\n  font-family: \"alimama-Regular\";\n  src: url('alimama.ttf');\n}"]}]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--6-1!./node_modules/postcss-loader/lib??ref--6-2!./src/assets/fonts/text.css
// module id = IdfM
// module chunks = 92